import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../core/login/services/auth.service';
import { environment } from '../environments/environment';

export const authorizationInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.backend.url)) {
    return next(req);
  }

  const authService = inject(AuthService);
  const request = getRequest(authService, req);
  const httpEvent = next(getRequest(authService, req));
  return addHandlerForExpiredToken(authService, httpEvent, request, next);
};

const getRequest = (authService: AuthService, req: HttpRequest<unknown>) =>
  authService.hasValidCsrfToken()
    ? req.clone({
        setHeaders: {
          Authorization: `CSRF ${authService.getCsrfToken()}`,
          'X-API-KEY': environment.backend.apiKey,
        },
      })
    : req.clone({
        setHeaders: {
          'X-API-KEY': environment.backend.apiKey,
        },
      });

const getRequestWithNewToken = (
  authService: AuthService,
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  return authService.getCsrfTokenRequest().pipe(
    switchMap(({ token }) => {
      authService.updateToken(token);
      return next(getRequest(authService, request));
    })
  );
};

const addHandlerForExpiredToken = (
  authService: AuthService,
  httpEvent: Observable<HttpEvent<unknown>>,
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  return httpEvent.pipe(
    catchError((requestError) => {
      if (requestError.status === 401) {
        return getRequestWithNewToken(authService, request, next);
      }
      return throwError(() => requestError);
    })
  );
};
